<template>
  <div>
    <!-- 身份证信息 -->
    <IDCardInfo
      :source="customerData"
      :list="IDCardList"
    />
    <!-- 驾驶证信息 -->
    <driversLicenseInfo
      :source="customerData"
      :list="personalDriversLicenseList"
    />
     <!-- 网约人证信息 -->
     <hailingLicenceInfo
      :source="customerData"
      :list="personalHailingLicenceList"
    />
  </div>
</template>
<script>
import IDCardInfo from '../../components/IDCardInfo.vue'
import driversLicenseInfo from '../../components/driversLicenseInfo.vue'
import hailingLicenceInfo from '../../components/hailingLicenceInfo.vue'
import configFn from './config'

export default {
  name: 'license',
  components: {
    IDCardInfo,
    driversLicenseInfo,
    hailingLicenceInfo,
  },
  props: ['customerData'],
  data() {
    const { IDCardList, personalDriversLicenseList, personalHailingLicenceList } = configFn.call(this)
    return {
      // 个人 身份证信息
      IDCardList,
      // 个人 驾驶证信息
      personalDriversLicenseList,
      // 个人 网约人证信息
      personalHailingLicenceList,
    }
  },
  methods: {

  },
}
</script>

<style>

</style>
